export class UrlHelper {

  public static DEFAULT_AUTH_PATH = '/';

  public static DEFAULT_UK_PATH = '/uk';
  public static DEFAULT_EN_PATH = '/en';

  public static PROFILE_DETAILS_PATH = '/profile/details';
  public static PROFILE_SCHOOL_DETAILS_PATH = 'profile/school';
  public static SCHOOL_SELECT_PATH = '/school-select';

  public static PRIVACY_PATH = '/privacy';
  public static TERMS_PATH = '/terms';

  public static SIGN_IN_PATH = '/sign-in';
  public static SIGN_UP_PATH = '/sign-up/';
  public static SIGN_UP_CONFIRM_PATH = '/sign-up-confirm/';
  public static SIGN_IN_SSO_PATH = '/sign-in-sso';
  public static INVITE_REQUEST_PATH = '/invite/request';
  public static PASS_RESET_PATH = '/pass-reset';
  public static PASS_RESET_CONFIRM_PATH = '/pass-reset-confirm/';
  public static ROLE_SELECT_PATH = '/role-select';

  public static CONTESTS_MANAGE_PATH = '/contests';
  public static CONTESTS_DETAILS_PATH = '/contests/';
  public static CONTESTS_HISTORY_PATH = '/contests-history';
  public static CONTESTS_AVAILABLE_PATH = '/contests-available';

  public static CONTEST_EXAM_PATH = '/contests/exam/';

  public static COMPETITIONS_LIST_PATH = '/competitions';
  public static COMPETITIONS_DETAILS_PATH = '/competitions/details';

  public static COORDINATORS_PATH = '/coordinators';

  public static HOSTS_PATH = '/hosts';

  public static TEACHERS_PATH = '/teachers';

  public static STUDENTS_PATH = '/students';

  public static SUPPORT_PATH = '/support';

  public static MIGRATIONS_PATH = '/migrations';

  public static STATS_DASHBOARD_PATH = '/stats';
  public static STATS_ENROL_PATH = '/stats/enrol';
  public static STATS_RESULTS_PATH = '/stats/results';
  public static STATS_CONTEST_PART_PATH = '/stats/contest';
  public static STATS_EXAM_RATING_PATH = '/stats/rating';
  public static STATS_SCHOOL_RATING_PATH = '/stats/rating/school';
  public static STATS_REGION_SCHOOLS_PATH = '/stats/exam/region';
  public static STATS_EXAM_CARD_PATH = '/stats/exam-card/';

  public static SETTINGS_DASHBOARD_PATH = '/settings';
  public static SETTINGS_SCHOOLS_PATH = `${UrlHelper.SETTINGS_DASHBOARD_PATH}/schools`;
}
